import { createSlice } from '@reduxjs/toolkit';

export const storeTimeSlots = createSlice({
  name: 'storeTimeSlots',
  initialState: {
    data: [],
  },

  reducers: {
    setStoreTimeSlots: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setStoreTimeSlots } = storeTimeSlots.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getStoreTimeSlots = (state) => {
  return state.storeTimeSlots.data;
};

export default storeTimeSlots.reducer;
